import React, { useState, useEffect } from 'react';
import './StrapiImageWithSkeleton.scss';
import Skeleton from '../Skeleton/Skeleton';
import { baseStrapiURL } from '../../services/config';

export default function StrapiImageWithSkeleton({
    picture,
    url,
    altPicture,
    className = "",
    borderRadius,
    loading,
    fetchpriority,
    size,
    breakpoints,
    withSkeleton=false,
}) {
    const [image, setImage] = useState(picture ? baseStrapiURL + picture.url : url);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const updateDimensions = () => {
            if (breakpoints && breakpoints.length > 0) {
                for (const bp of breakpoints) {
                    if (window.matchMedia(`(min-width: ${bp.b}px)`).matches) {
                        setDimensions({ width: bp.w, height: bp.h });
                    }
                }
            }
        };

        updateDimensions(); // Appel initial
        window.addEventListener('resize', updateDimensions);

        return () => window.removeEventListener('resize', updateDimensions);
    }, [breakpoints]);


    useEffect(() => {
        const img = new Image();
        img.src = picture ? baseStrapiURL + picture.url : url;
        img.onload = () => {
            if (picture) {
                if (size) {
                    switch (size) {
                        case 'thumbnail':
                            setImage(
                                picture.formats && picture.formats.thumbnail ?
                                    baseStrapiURL + picture.formats.thumbnail.url
                                :
                                    baseStrapiURL + picture.url    
                            );
                            break;
                        case 'small':
                            setImage(
                                picture.formats && picture.formats.small ?
                                    baseStrapiURL + picture.formats.small.url
                                :
                                    baseStrapiURL + picture.url    
                            );
                            break;
                        case 'medium':
                            setImage(
                                picture.formats && picture.formats.medium ?
                                    baseStrapiURL + picture.formats.medium.url
                                :
                                    baseStrapiURL + picture.url    
                            );
                            break;
                        case 'large':
                            setImage(
                                picture.formats && picture.formats.large ?
                                    baseStrapiURL + picture.formats.large.url
                                :
                                    baseStrapiURL + picture.url    
                            );
                            break;
                        default:
                            setImage(baseStrapiURL + picture.url);
                    }
                }
                else {
                    setImage(baseStrapiURL + picture.url);
                }
            }
            else {
                setImage(url);
            }
            setIsImageLoaded(true);
        };
    }, [picture, url]);

    return (
        <>
            {!isImageLoaded && withSkeleton ? (
                <Skeleton
                    width={dimensions.width}
                    height={dimensions.height}
                    bkgColor="#EEE6DB"
                    animColor="#F5F0ED"
                    margin="0"
                    borderRadius={borderRadius}
                />
            ) : (
                <img
                    src={image}
                    alt={picture ? (picture.alternativeText === null ? '' : picture.alternativeText) : altPicture}
                    loading={loading}
                    fetchpriority={fetchpriority}
                    className={`strapi-image-skeleton ${className}`}
                    style={{
                        borderRadius,
                    }}
                />
            )}
        </>
    );
};